import React, { Component } from 'react';
import './Projects.css';

export default class Projects extends Component {


    render() {
        return (
            <div class="container">
                <div>
                    <h1>Projects</h1>
                    <div class="row">
                        <div class="col">
                            <div className="project_type_title">
                                WORK EXPERIENCE
                            </div>
                            <div className="desc_block">
                                <h4>Symantec Endpoint Protection Manager</h4>
                                <ul>
                                    <li>
                                        Designed and developed web portal components (AngularJS 1.x, gulp.js, Java/Maven backend) and implemented
        D3.js based charts to display threat information for a cloud based web application.
                                    </li>
                                    <li>
                                        Developed REST API with Java Spring framework consumed by Endpoint Manager to push policies to its clients.
                                    </li>
                                    <li>
                                        Developed Bridge interface component as an microservice (to massage data) and deployed in OpenShift containers.
                                    </li>
                                    <li>
                                        Redesigned Endpoint Protection Manager (Java, PHP, AngularJS) User Interface with responsive layout.
                                    </li>
                                </ul>
                            </div>
                            <div className="desc_block">
                                <h4>SAP DSX Custom Components</h4>
                                <ul>
                                    <li>Developed dynamic custom components for SAP Design Studio using Eclipse SDK and HighCharts API in JavaScript.</li>
                                    <li>
                                        Designed and Developed “BI News Page”, an AngularJS application using Bing Search API and Google Feed API.
                                    </li>
                                </ul>
                            </div>
                            <div className="desc_block">
                                <h4>Rapport iPad Client Brief Meeting Scheduler</h4>
                                <ul>
                                    <li>Implemented an interactive Client Briefing Book, a meeting scheduler in ASP.NET MVC and delivered as iPad App.</li>
                                </ul>
                            </div>
                            <div className="project_type_title">
                                ACADEMIC PROJECTS
                            </div>
                            <div className="desc_block">
                                <h4>Tweet Topic Summarization</h4>
                                <ul>
                                    <li>Stream large volume of tweets using Apache Storm and analyze the content & tweets for keyword based summary.</li>
                                    <li>Implemented tf-idf algorithm using Apache Spark & LDA algorithm using Apache Mahout for tweet summarization.</li>
                                </ul>
                            </div>
                            <div className="desc_block">
                                <h4>Spatial Information Retrieval</h4>
                                <ul>
                                    <li>Built an information retrieval framework for indexing, searching and querying documents based on spatial info.</li>
                                    <li>Used Apache Lucene for building incremental index and Used WordNet – JAWS API for synonym matching.</li>
                                </ul>
                            </div>
                            <div className="desc_block">
                                <h4>Real Time Object Detection and Tracking</h4>
                                <ul>
                                    <li>Developed a C++ application which detects logo in T-shirt using SURF and SIFT algorithms.</li>
                                    <li>Used OpenCV library and tracked human based on Haar feature based cascade classifiers.</li>
                                </ul>
                            </div>
                            <div className="desc_block">
                                <h4>Secure File Transfer System</h4>
                                <ul>
                                    <li>Developed a Java application in which only authenticated client can download files from a secure file system. Validates client using an authentication server and encrypts file to transfer via relay server.</li>
                                    <li>Generated unique 256 bit RSA keys and permanent shared keys for encrypting the communication</li>
                                </ul>
                            </div>
                            <div className="project_type_title">
                                OTHER PROJECTS
                            </div>
                            <div className="desc_block">
                                <h4>Smart Profiler Android Application</h4>
                                <ul>
                                    <li>Developed an automatic volume control app “Smart profiler” which investigates nearby noise levels and smartly controls device volume. Used Facebook API and GPS to identify nearby friends.</li>
                                </ul>
                            </div>
                            <div className="desc_block">
                                <h4>Image Grabber and Feed Parser</h4>
                                <ul>
                                    <li>Developed “blog-gallery” responsive single page application (ReactJS, Google Developer API, Node.js, webpack.js).</li>
                                </ul>
                            </div>
                            <div className="project_type_title">
                                ACADEMIC COURSES
                            </div>
                            <div className="desc_block">
                                <ul>
                                    <li>Design and Analysis of Algorithms</li>
                                    <li>Network Security</li>
                                    <li>Object Oriented Analysis and Design</li>
                                    <li>Video Analytics</li>
                                    <li>Statistics for Data Science</li>
                                    <li>Database Design</li>
                                    <li>Big Data Analytics and Management</li>
                                    <li>Machine Learning</li>
                                    <li>Information Retrieval</li>
                                    <li>Natural Language Processing</li>
                                    <li>Web Programming Languages</li>
                                </ul>
                            </div>
                        </div>

                    </div>
                </div>
                <div>

                </div>
            </div>
        )
    }

}